import React, {Component} from 'react';
import styled, { withTheme } from 'styled-components';
import {connect} from 'react-redux'
import ReactPixel from 'react-facebook-pixel';

class Confirmation extends Component {
    state = {
        prod: false
    }

    componentDidMount = () => {
        if (window.location.href.includes("online-sales.mazda.com.sg")) {
            ReactPixel.init('273792070524054');
            ReactPixel.pageView();

            this.setState({
                prod: true
            })
          }
    }

    onFinish = () => {
        window.location.href = 'https://www.mazda.com.sg/';
    }
    
    render() {
       
        const { className } = this.props;
        const state = this.state;
        return <div className={className}>
        
            <div className='wrapper'>
                {
                    state.prod ? <img border="0" style={{width: 0, height: 0, position: "absolute"}} src="https://r.turn.com/r/beacon?b2=EJ_ZYGLqNH3SVXsAWLipakInQn2Pk0SR57cty8Xq-QOzNPlUFo4chDo95bs8J6m4UiOWDznz2dTVktunAdcZ9g&cid=" /> : '' 
                }
                <div className="thank-wrap">
                    <div className="thank-title">
                        Thank you for making Mazda your car of choice
                    </div>
                    <div className="thank-txt">
                        <div>Our Sales Consultant will be in contact with you shortly.</div>
                    </div>
                    <div className="thank-btn-Wrap">
                        <button className="thank-btn" onClick={this.onFinish}>
                            Back to Home Page
                        </button>
                    </div>
                </div>
            </div>
        </div>;
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        ...state.calculator,
        context: state.context,
        calculator: state.calculator,
        email: state.form
    };
};

const mapDispatchToProps = dispatch => {
    return {
        async onSubmit() { 
            // const result = await dispatch(submit());
            // console.log('onSubmit:result: ', result);
        }
           
        
    }
};

const ConnectedConfirmation = connect(
    mapStateToProps,
    mapDispatchToProps
)(Confirmation);

let StyledConfirmation = styled(ConnectedConfirmation)`
width: 100%;

.thank-wrap {
    width: 100%;
    position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  @media (max-width: 420px) {
      width: 350px;

      .thank-block {
          display: block;
      }
  }
}

.thank-title {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 30px;
    color: #101010;
    letter-spacing: 3px;
}

.thank-txt {
    color: #101010;
    font-size: 15px;
    margin-bottom: 30px;
}

.thank-txt {
    
}

.wrapper{
    max-width: 450px;
    padding: 5px 25px;
    margin: 25px auto; 
    text-align: center;
    margin-top: 0;

    @media (min-width: 1000px) {
        max-width: 450;
        padding-left: 0;
        padding-right: 0; 
    }
}
.thank-btn-wrap {
    max-width: 450px;
    margin: 0 auto;
}
.thank-btn {
    display: inline-block;
    background-color: #0F0F0F;
    color: #FFF;
    font-size: 13px;
    letter-spacing: 1.95px;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 0;
    text-align: center;
    line-height: 60px;
    height: 60px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    max-width: 450px;

    &:disabled {
        opacity: 0.5;
        cursor: initial;
    }
}
`;

export default StyledConfirmation


// WEBPACK FOOTER //
// ./src/components/configurator/Thank.js